import { Injectable } from '@angular/core';
import { ApiService } from './core/api.service';
import { InvestorModel } from '../models/investor/investor-vm';
import { of } from 'rxjs';
import _, { result } from 'lodash';
import { environment } from 'src/environments/environment';
import { HttpHeaders } from '@angular/common/http';
import { IdbService } from 'src/app/services/indexdb.service';
@Injectable({
  providedIn: 'root'
})
export class InvestorService {

  constructor(private apiService: ApiService, private idb_service: IdbService,) { }

  public investorActiveBankList = null;
  public async getInvestorActiveBankList(swpReport: InvestorModel.InvestorVM) {
    const url = this.apiService.getFcApiUrl('/fcapi/investor/active-bank-list');
    const data =
    {
      InvestorId: swpReport.InvestorId,
      RefKey: "string",
      loader: swpReport['loader']
    }
    const httpOptions = await this.apiService.getHttpOptionsByToken();
    let result;
    try {
      const response = await this.apiService.post(url, data, httpOptions);
      if (response.Data) {
        result = new InvestorModel.ActiveBankListOM(response.Data).Data;
        this.investorActiveBankList = of(result);
      }
      return result;
    } catch (error) {
      //  this.apiService.handleError(error);
      throw error;
    }
  }

  public async getBankListForPayments(bankList: InvestorModel.BankListForPaymentVM) {
    const url = this.apiService.getFcApiUrl('/fcapi/investor/bank-list/for-payments');
    const data = {
      investorId: bankList.investorId,
    }
    const httpOptions = await this.apiService.getHttpOptionsByToken();
    let result;
    try {
      const response = await this.apiService.post(url, data, httpOptions);
      if (response.Data) {
        result = response.Data;
      }
      return result;
    }
    catch (error) {
      throw error;
    }
  }

  public investorMandateList = null;
  public async getInvestorMandateList(swpReport: InvestorModel.InvestorVM) {
    const url = this.apiService.getFcApiUrl('/fcapi/investor/bank-mandates');
    const data =
    {
      InvestorId: swpReport.InvestorId,
      RefKey: "string",
      loader: swpReport['loader']
    }
    const httpOptions = await this.apiService.getHttpOptionsByToken();
    let result;
    try {
      const response = await this.apiService.post(url, data, httpOptions);
      if (response.Data) {
        result = new InvestorModel.MandateListOM(response.Data).Data;
        this.investorMandateList = of(result);
      }
      return result;
    } catch (error) {
      throw error;
    }
  }

  public async getHierarchyContactInfo() {
    const url = this.apiService.getFcApiUrl('/fcapi/investor/hierarchy-contact-info');
    const data = {}
    const httpOptions = await this.apiService.getHttpOptionsByToken();
    let result;
    try {
      const response = await this.apiService.post(url, data, httpOptions);
      if (response.Data) {
        result = response.Data;
      }
      return result;
    }
    catch (error) {
      throw error;
    }
  }

  public async updateInvestorPassword(_data: InvestorModel.ChangePasswordVM) {
    const url = this.apiService.getFcApiUrl('/fcapi/account/change-password');
    const data = {
      OldPassword: _data.OldPassword,
      NewPassword: _data.NewPassword,
      RefKey: "string",
      ContextMenuCode: "string",
      loader: _data['loader']
    }
    const httpOptions = await this.apiService.getHttpOptionsByToken();
    let result;
    try {
      const response = await this.apiService.post(url, data, httpOptions);
      if (response.Data) {
        result = response.Data;
      }
      return result;
    }
    catch (error) {
      throw error;
    }
  }

  public async getPurchaseOrderSchemeData(_data: InvestorModel.PurOrderSchemeDataVM) {
    const url = this.apiService.getFcApiUrl('/fcapi/mf-order/pur-order/get-scheme-data');
    const data = {
      SchemeCode: _data.SchemeCode,
      DividendFlag: _data.DividendFlag,
      RefKey: "string",
      loader: _data['loader']
    }
    const httpOptions = await this.apiService.getHttpOptionsByToken();
    let result;
    try {
      const response = await this.apiService.post(url, data, httpOptions);
      if (response.Data) {
        result = new InvestorModel.PurOrderSchemeDataOM(response.Data).Data;
        this.investorMandateList = of(result);
      }
      return result;
    } catch (error) {
      throw error;
    }
  }

  public async getAddPurchaseOrderSchemeData(_data: InvestorModel.PurOrderSchemeDataVM) {
    const url = this.apiService.getFcApiUrl('/fcapi/mf-order/add-pur-order/get-scheme-data');
    const data = {
      SchemeCode: _data.SchemeCode,
      DividendFlag: _data.DividendFlag,
      RefKey: "string",
    }
    const httpOptions = await this.apiService.getHttpOptionsByToken();
    let result;
    try {
      const response = await this.apiService.post(url, data, httpOptions);
      if (response.Data) {
        result = new InvestorModel.PurOrderSchemeDataOM(response.Data).Data;
        this.investorMandateList = of(result);
      }
      return result;
    } catch (error) {
      throw error;
    }
  }

  public async getSipOrderSchemeData(_data: InvestorModel.PurOrderSchemeDataVM) {
    const url = this.apiService.getFcApiUrl('/fcapi/mf-order/sip-order/get-scheme-data');
    const data = {
      SchemeCode: _data.SchemeCode,
      DividendFlag: _data.DividendFlag,
      RefKey: "string",
    }
    const httpOptions = await this.apiService.getHttpOptionsByToken();
    let result;
    try {
      const response = await this.apiService.post(url, data, httpOptions);
      if (response.Data) {
        result = new InvestorModel.PurOrderSchemeDataOM(response.Data).Data;
        this.investorMandateList = of(result);
      }
      return result;
    } catch (error) {
      throw error;
    }
  }

  public async getSwpOrderSchemeData(_data: InvestorModel.PurOrderSchemeDataVM) {
    const url = this.apiService.getFcApiUrl('/fcapi/mf-order/swp-order/get-scheme-data');
    const data = {
      SchemeCode: _data.SchemeCode,
      DividendFlag: _data.DividendFlag,
      RefKey: "string",
      loader: _data['loader']
    }
    const httpOptions = await this.apiService.getHttpOptionsByToken();
    let result;
    try {
      const response = await this.apiService.post(url, data, httpOptions);
      if (response.Data) {
        result = new InvestorModel.PurOrderSchemeDataOM(response.Data).Data;
        this.investorMandateList = of(result);
      }
      return result;
    } catch (error) {
      throw error;
    }
  }

  public async getStpOrderSchemeData(_data: InvestorModel.PurOrderSchemeDataVM) {
    const url = this.apiService.getFcApiUrl('/fcapi/mf-order/stp-order/get-scheme-data');
    const data = {
      SchemeCode: _data.SchemeCode,
      DividendFlag: _data.DividendFlag,
      RefKey: "string",
      loader: _data['loader']
    }
    const httpOptions = await this.apiService.getHttpOptionsByToken();
    let result;
    try {
      const response = await this.apiService.post(url, data, httpOptions);
      if (response.Data) {
        result = new InvestorModel.PurOrderSchemeDataOM(response.Data).Data;
        this.investorMandateList = of(result);
      }
      return result;
    } catch (error) {
      throw error;
    }
  }

  public async getReedemOrderSchemeData(_data: InvestorModel.PurOrderSchemeDataVM) {
    const url = this.apiService.getFcApiUrl('/fcapi/mf-order/red-order/get-scheme-data');
    const data = {
      SchemeCode: _data.SchemeCode,
      DividendFlag: _data.DividendFlag,
      RefKey: "string",
      loader: _data['loader']
    }
    const httpOptions = await this.apiService.getHttpOptionsByToken();
    let result;
    try {
      const response = await this.apiService.post(url, data, httpOptions);
      if (response.Data) {
        result = new InvestorModel.PurOrderSchemeDataOM(response.Data).Data;
        this.investorMandateList = of(result);
      }
      return result;
    } catch (error) {
      throw error;
    }
  }

  public async getSwitchOrderSchemeData(_data: InvestorModel.PurOrderSchemeDataVM) {
    const url = this.apiService.getFcApiUrl('/fcapi/mf-order/sw-order/get-scheme-data');
    const data = {
      SchemeCode: _data.SchemeCode,
      DividendFlag: _data.DividendFlag,
      RefKey: "string",
      loader: _data['loader']
    }
    const httpOptions = await this.apiService.getHttpOptionsByToken();
    let result;
    try {
      const response = await this.apiService.post(url, data, httpOptions);
      if (response.Data) {
        result = new InvestorModel.PurOrderSchemeDataOM(response.Data).Data;
        this.investorMandateList = of(result);
      }
      return result;
    } catch (error) {
      throw error;
    }
  }

  public async getSipOrderSchemeInfoData(_data: InvestorModel.SipOrderSchemeInfoVM) {
    const url = this.apiService.getFcApiUrl('/fcapi/mf/scheme/info/for-sip-order');
    const data = {
      BseSchemeCode: _data.BseSchemeCode,
      RefKey: "string",
    }
    const httpOptions = await this.apiService.getHttpOptionsByToken();
    let result;
    try {
      const response = await this.apiService.post(url, data, httpOptions);
      if (response.Data) {
        result = new InvestorModel.sipOrderSchemeInfoOM(response.Data).Data;
        this.investorMandateList = of(result);
      }
      return result;
    } catch (error) {
      throw error;
    }
  }

  public async getStpOrderSchemeInfo(_data: InvestorModel.SipOrderSchemeInfoVM) {
    const url = this.apiService.getFcApiUrl('/fcapi/mf/scheme/info/for-stp-order');
    const data = {
      BseSchemeCode: _data.BseSchemeCode,
      RefKey: "string",
    }
    const httpOptions = await this.apiService.getHttpOptionsByToken();
    let result;
    try {
      const response = await this.apiService.post(url, data, httpOptions);
      if (response.Data) {
        result = new InvestorModel.sipOrderSchemeInfoOM(response.Data).Data;
        this.investorMandateList = of(result);
      }
      return result;
    } catch (error) {
      throw error;
    }
  }

  public async placeOrderPurchase(_data: InvestorModel.PurchaseOrderVM) {
    const url = this.apiService.getFcApiUrl('/fcapi/mf-order/place-order/purchase');
    const data = {
      SchCode: _data.SchCode,
      SchemeName: _data.SchemeName,
      SchemeToken: _data.SchemeToken,
      FolioNo: _data.FolioNo,
      Amount: _data.Amount,
      ChequeNumber: _data.ChequeNumber,
      TranMode: _data.TranMode,
      BasketCode: _data.BasketCode,
      GoalId: _data.GoalId,
      InvestorId: _data.InvestorId,
      RefKey: "string",
      ContextMenuCode: "string"
    }
    const httpOptions = await this.apiService.getHttpOptionsByToken();
    let result;
    try {
      const response = await this.apiService.post(url, data, httpOptions);
      if (response.Data) {
        result = response.Data;
      }
      return result;
    }
    catch (error) {
      throw error;
    }
  }

  public async placeOrderAddPurchase(_data: InvestorModel.PurchaseOrderVM) {
    const url = this.apiService.getFcApiUrl('/fcapi/mf-order/place-order/additional-purchase');
    const data = {
      SchCode: _data.SchCode,
      SchemeName: _data.SchemeName,
      SchemeToken: _data.SchemeToken,
      FolioNo: _data.FolioNo,
      Amount: _data.Amount,
      ChequeNumber: _data.ChequeNumber,
      TranMode: _data.TranMode,
      BasketCode: _data.BasketCode,
      GoalId: _data.GoalId,
      InvestorId: _data.InvestorId,
      RefKey: "string",
      ContextMenuCode: "string"
    }
    const httpOptions = await this.apiService.getHttpOptionsByToken();
    let result;
    try {
      const response = await this.apiService.post(url, data, httpOptions);
      if (response.Data) {
        result = response.Data;
      }
      return result;
    }
    catch (error) {
      throw error;
    }
  }

  public async get2faOrderInfo(_data: InvestorModel.Order2faInfo) {
    const url = this.apiService.getFcApiUrl('/fcapi/mf-order/v1/order-2fa/info');
    const data = {
      refkey: "string",
      investorId: _data.investorId,
      gwsOrderId: _data.gwsOrderId,
      tranType: _data.tranType,
      loader: _data['loader']
    }
    const httpOptions = await this.apiService.getHttpOptionsByToken();
    let result;
    try {
      const response = await this.apiService.post(url, data, httpOptions);
      if (response.Data) {
        result = response.Data;
      }
      return result;
    }
    catch (error) {
      throw error;
    }
  }

  public async send2faOrderOTP(_data: InvestorModel.Order2faSendOTP) {
    const url = this.apiService.getFcApiUrl('/fcapi/mf-order/v1/order-2fa/fc-otp/send-otp');
    const data = {
      refKey: "string",
      investorId: _data.investorId,
      gwsOrderId: _data.gwsOrderId,
      tranType: _data.tranType,
    }
    const httpOptions = await this.apiService.getHttpOptionsByToken();
    let result;
    try {
      const response = await this.apiService.post(url, data, httpOptions);
      if (response.Data) {
        result = response.Data;
      }
      return result;
    }
    catch (error) {
      throw error;
    }
  }

  public async verify2faOrderOTP(_data: InvestorModel.Order2faVerifyOTP) {
    const url = this.apiService.getFcApiUrl('/fcapi/mf-order/v1/order-2fa/fc-otp/verify-otp');
    const data = {
      refKey: "string",
      investorId: _data.investorId,
      gwsOrderId: _data.gwsOrderId,
      tranType: _data.tranType,
      holderSeq: _data.holderSeq,
      otpKey: _data.otpKey,
      otpValue: _data.otpValue
    }
    const httpOptions = await this.apiService.getHttpOptionsByToken();
    let result;
    try {
      const response = await this.apiService.post(url, data, httpOptions);
      return response?.Data;
    }
    catch (error) {
      throw error;
    }
  }

  public async getOrderDetails(_data: InvestorModel.OrderDetailVM) {
    const url = this.apiService.getFcApiUrl('/api/reports/mf/order-detail')
    const data = {
      ContextMenuCode: _data.ContextMenuCode,
      InvestorId: _data.InvestorId,
      OrderId: _data.OrderId,
      TranType: _data.TranType,
      RefKey: "string"
    }
    const httpOptions = await this.apiService.getHttpOptionsByToken();
    let result;
    try {
      const response = await this.apiService.post(url, data, httpOptions);
      if (response) {
        result = response;
      }
      return result;
    }
    catch (error) {
      throw error;
    }
  }

  public async placeOrderSip(_data: InvestorModel.SipOrderVM) {
    const url = this.apiService.getFcApiUrl('/fcapi/mf-order/register/sip');
    const data = {
      InvestorId: _data.InvestorId,
      SchCode: _data.SchCode,
      SchemeName: _data.SchemeName,
      SchemeToken: _data.SchemeToken,
      FolioNo: _data.FolioNo,
      Amount: _data.Amount,
      Frequency: _data.Frequency,
      SipStartDate: _data.SipStartDate,
      NoOfInstallments: _data.NoOfInstallments,
      BankMandateId: _data.BankMandateId,
      IsFirstOrderToday: _data.IsFirstOrderToday,
      ChequeNumber: _data.ChequeNumber,
      TranMode: _data.TranMode,
      BasketCode: _data.BasketCode,
      GoalId: _data.GoalId,
      EnhancedSipType: _data.EnhancedSipType,
      EnhancedSipSwitchSchemeCode: _data.EnhancedSipSwitchSchemeCode,
      EnhancedSipSwitchAmount: _data.EnhancedSipSwitchAmount,
      EnhancedSipSwitchBSESchemeToken: _data.EnhancedSipSwitchBSESchemeToken,
      RefKey: "string",
      ContextMenuCode: "string"
    }
    const httpOptions = await this.apiService.getHttpOptionsByToken();
    let result;
    try {
      const response = await this.apiService.post(url, data, httpOptions);
      if (response.Data) {
        result = response.Data;
      }
      return result;
    }
    catch (error) {
      throw error;
    }
  }

  public async placeOrderStp(_data: InvestorModel.StpOrderVM) {
    const url = this.apiService.getFcApiUrl('/fcapi/mf-order/register/stp');
    const data = {
      InvestorId: _data.InvestorId,
      SwitchFromSchCode: _data.SwitchFromSchCode,
      SwitchToSchCode: _data.SwitchToSchCode,
      SwitchFromBseSchemeToken: _data.SwitchFromBseSchemeToken,
      SwitchToBseSchemeToken: _data.SwitchToBseSchemeToken,
      SwitchFromFolioNo: _data.SwitchFromFolioNo,
      FolioTranMode: _data.FolioTranMode,
      InstallmentAmount: _data.InstallmentAmount,
      Frequency: _data.Frequency,
      StpStartDate: _data.StpStartDate,
      NoOfInstallments: _data.NoOfInstallments,
      IsFirstOrderToday: _data.IsFirstOrderToday,
      RefKey: "string",
      ContextMenuCode: "string"
    }
    const httpOptions = await this.apiService.getHttpOptionsByToken();
    let result;
    try {
      const response = await this.apiService.post(url, data, httpOptions);
      if (response.Data) {
        result = response.Data;
      }
      return result;
    }
    catch (error) {
      throw error;
    }
  }

  public async placeOrderSwp(_data: InvestorModel.SwpOrderVM) {
    const url = this.apiService.getFcApiUrl('/fcapi/mf-order/register/swp');
    const data = {
      InvestorId: _data.InvestorId,
      SchCode: _data.SchCode,
      BseSchemeToken: _data.BseSchemeToken,
      FolioNo: _data.FolioNo,
      FolioTranMode: _data.FolioTranMode,
      WithdrawIn: _data.WithdrawIn,
      WithdrawValue: _data.WithdrawValue,
      Frequency: _data.Frequency,
      SwpStartDate: _data.SwpStartDate,
      NoOfInstallments: _data.NoOfInstallments,
      IsFirstOrderToday: _data.IsFirstOrderToday,
      BankAccountNo: _data.BankAccountNo,
      RefKey: "string",
      ContextMenuCode: "string"
    }
    const httpOptions = await this.apiService.getHttpOptionsByToken();
    let result;
    try {
      const response = await this.apiService.post(url, data, httpOptions);
      if (response.Data) {
        result = response.Data;
      }
      return result;
    }
    catch (error) {
      throw error;
    }
  }

  public async placeReedemOrder(_data: InvestorModel.ReedemOrderVM) {
    const url = this.apiService.getFcApiUrl('/fcapi/mf-order/place-order/redemption');
    const data = {
      InvestorId: _data.InvestorId,
      SchCode: _data.SchCode,
      SchemeToken: _data.SchemeToken,
      FolioNo: _data.FolioNo,
      FolioTranMode: _data.FolioTranMode,
      RedemptionIn: _data.RedemptionIn,
      RedemptionValue: _data.RedemptionValue,
      BankAccountNo: _data.BankAccountNo,
      RefKey: "string",
      ContextMenuCode: "string"
    }
    const httpOptions = await this.apiService.getHttpOptionsByToken();
    let result;
    try {
      const response = await this.apiService.post(url, data, httpOptions);
      if (response.Data) {
        result = response.Data;
      }
      return result;
    }
    catch (error) {
      throw error;
    }
  }

  public async placeSwitchOrder(_data: InvestorModel.SwitchOrderVM) {
    const url = this.apiService.getFcApiUrl('/fcapi/mf-order/place-order/switch');
    const data = {
      InvestorId: _data.InvestorId,
      SwitchFromSchCode: _data.SwitchFromSchCode,
      SwitchToSchCode: _data.SwitchToSchCode,
      SwitchFromBseSchemeToken: _data.SwitchFromBseSchemeToken,
      SwitchToBseSchemeToken: _data.SwitchToBseSchemeToken,
      SwitchFromFolioNo: _data.SwitchFromFolioNo,
      SwitchToFolioNo: _data.SwitchToFolioNo,
      FolioTranMode: _data.FolioTranMode,
      SwitchIn: _data.SwitchIn,
      SwitchValue: _data.SwitchValue,
      RefKey: "string",
      ContextMenuCode: "string"
    }
    const httpOptions = await this.apiService.getHttpOptionsByToken();
    let result;
    try {
      const response = await this.apiService.post(url, data, httpOptions);
      if (response.Data) {
        result = response.Data;
      }
      return result;
    }
    catch (error) {
      throw error;
    }
  }

  public async getBankMandateConfig(_data: InvestorModel.BankMandateConfigVM) {
    const url = this.apiService.getFcApiUrl('/fcapi/investor/bank-mandates/with-config/refresh');
    const data = {
      investorId: _data.investorId,
      panNumber: _data.panNumber,
      refKey: "string",
      contextMenuCode: "string",
      loader: _data['loader']
    };
    const httpOptions = await this.apiService.getHttpOptionsByToken();
    let result;
    try {
      const response = await this.apiService.post(url, data, httpOptions);
      if (response.Data) {
        result = response.Data;
      }
      return result;
    }
    catch (error) {
      throw error;
    }
  }

  public async DownloadPreFilledMandteForm(_data: InvestorModel.MandateFormVM) {
    const url = this.apiService.getFcApiUrl('/fcapi/investor/download-pre-filled-mandate-form');
    const data = {
      refKey: "string",
      investorId: _data.investorId,
      rowId: _data.rowId
    };
    const httpOptions = await this.apiService.getHttpOptionsByToken();
    let result;
    try {
      const response = await this.apiService.post(url, data, httpOptions);
      if (response.Data) {
        result = response.Data;
      }
      return result;
    }
    catch (error) {
      throw error;
    }
  }

  public async UploadNachMandateForm(_data: { RowId: number; MandateId: string; file: File }) {
    const url = this.apiService.getFcApiUrl('/fcapi/investor/upload-nach-mandate-form');

    const formData = new FormData();
    formData.append('RowId', _data.RowId.toString());
    formData.append('MandateId', _data.MandateId);
    formData.append('file', _data.file, _data.file.name);

    const httpOptions = await this.apiService.getHttpOptionsByTokenF();

    try {
      const response = await this.apiService.post(url, formData, httpOptions);
      return response?.Data;
    } catch (error) {
      throw error;
    }
  }

  public async AddSignaturetoDoc(_data: { PanNumber: string; InvestorId: number; DocType: string, file: File; }) {
    const url = this.apiService.getFcApiUrl('/fcapi/investor/add-signature-to-doc');
    const formData = new FormData();
    formData.append('PanNumber', _data.PanNumber);
    formData.append('InvestorId', _data.InvestorId.toString());
    formData.append('DocType', _data.DocType);
    formData.append('file', _data.file, _data.file.name);
    const httpOptions = await this.apiService.getHttpOptionsByTokenF();
    try {
      const response = await this.apiService.post(url, formData, httpOptions);
      return response?.Data;
    } catch (error) {
      throw error;
    }
  }

  public async getSwitchSchemeDetail(_data: InvestorModel.SwitchOrderSchemeDetailVM) {
    const url = this.apiService.getFcApiUrl('/fcapi/mf-order/sw-order/get-scheme-data/by-bse-code');
    const data = {
      BseSchemeCode: _data.BseSchemeCode,
      RefKey: "string",
      loader: _data['loader']
    }
    const httpOptions = await this.apiService.getHttpOptionsByToken();
    let result;
    try {
      const response = await this.apiService.post(url, data, httpOptions);
      if (response.Data) {
        result = new InvestorModel.SwitchOrderSchemeDetailOM(response.Data).Data;
        this.investorMandateList = of(result);
      }
      return result;
    } catch (error) {
      throw error;
    }
  }

  public async getTransactionDetails(_data: InvestorModel.TransactionDetailsVM) {
    const url = this.apiService.getFcApiUrl('/fcapi/reports/mf/live-portfolio/transactions');
    const data = {
      FolioNo: _data.FolioNo,
      SchemeCode: _data.SchemeCode,
      AsOnDate: _data.AsOnDate,
      loader: _data['loader']
    }
    const httpOptions = await this.apiService.getHttpOptionsByToken();
    let result;
    try {
      const response = await this.apiService.post(url, data, httpOptions);
      if (response.Data) {
        result = new InvestorModel.TransactionDetailsOM(response.Data).Data;
        this.investorMandateList = of(result);
      }
      return result;
    } catch (error) {
      throw error;
    }
  }

  public async getCollectionReport(_data: InvestorModel.CollectionReportVM) {
    const url = this.apiService.getFcApiUrl('/fcapi/reports/mf/collection-report');
    const data = {
      ReportType: _data.ReportType,
      arnNumber: _data.arnNumber,
      AmcId: _data.AmcId,
      SchCode: _data.SchCode,
      CategoryCode: _data.CategoryCode,
      FromDate: _data.FromDate,
      ToDate: _data.ToDate,
      RefKey: "string",
      loader: _data['loader']
    }
    const httpOptions = await this.apiService.getHttpOptionsByToken();
    let result;
    try {
      const response = await this.apiService.post(url, data, httpOptions);
      if (response.Data) {
        result = new InvestorModel.CollectionReportOM(response.Data).Data;
        this.investorMandateList = of(result);
      }
      return result;
    } catch (error) {
      throw error;
    }
  }

  public async getAUMReport(_data: InvestorModel.AUMReportVM) {
    const url = this.apiService.getFcApiUrl('/fcapi/reports/mf/aum-report');
    const data = {
      ReportType: _data.ReportType,
      AsOnDate: _data.AsOnDate,
      ArnNumber: _data.ArnNumber,
      AmcId: _data.AmcId,
      SchCode: _data.SchCode,
      CategoryCode: _data.CategoryCode,
      RefKey: "string",
      loader: _data['loader']
    }
    const httpOptions = await this.apiService.getHttpOptionsByToken();
    let result;
    try {
      const response = await this.apiService.post(url, data, httpOptions);
      if (response.Data) {
        result = new InvestorModel.AUMReportOM(response.Data).Data;
        this.investorMandateList = of(result);
      }
      return result;
    } catch (error) {
      throw error;
    }
  }

  public async getAMCFolios(_data: InvestorModel.InvestorAMCFoliosVM) {
    const url = this.apiService.getFcApiUrl('/fcapi/investor/amc-folios');
    const data = {
      AmcId: _data.AmcId,
      TranMode: _data.TranMode,
      InvestorId: _data.InvestorId,
      RefKey: "string",
      loader: _data['loader']
    }
    const httpOptions = await this.apiService.getHttpOptionsByToken();
    let result;
    try {
      const response = await this.apiService.post(url, data, httpOptions);
      if (response.Data) {
        result = new InvestorModel.InvestorAMCFoliosOM(response.Data).Data;
        this.investorMandateList = of(result);
      }
      return result;
    } catch (error) {
      throw error;
    }
  }

  public async getNewFormStatus(_data: InvestorModel.NewFormVM) {
    const url = this.apiService.getFcApiUrl('/fcapi/investor/card-info/for-mf-order');
    const data = {
      InvestorId: _data.InvestorId,
      RefKey: "string",
    }
    const httpOptions = await this.apiService.getHttpOptionsByToken();
    let result;
    try {
      const response = await this.apiService.post(url, data, httpOptions);
      if (response.Data) {
        result = new InvestorModel.NewFormOM(response.Data).Data;
        this.investorMandateList = of(result);
      }
      return result;
    } catch (error) {
      throw error;
    }
  }

  public async getSchemeListForSwitchOrder(_data: InvestorModel.SchemeListForSwitchVM) {
    const url = this.apiService.getFcApiUrl('/fcapi/mf/scheme/list/for-switch-order');
    const data = {
      FolioTranMode: _data.FolioTranMode,
      SchemeCode: _data.SchemeCode,
      RefKey: "string",
      loader: _data['loader']
    }
    const httpOptions = await this.apiService.getHttpOptionsByToken();
    let result;
    try {
      const response = await this.apiService.post(url, data, httpOptions);
      if (response.Data) {
        result = new InvestorModel.SchemeListForSwitchOM(response.Data).Data;
        this.investorMandateList = of(result);
      }
      return result;
    } catch (error) {
      throw error;
    }
  }

  public async getSwitchSchemeListForStpOrder(_data: InvestorModel.SchemeListForSwitchVM) {
    const url = this.apiService.getFcApiUrl('/fcapi/mf/scheme/list/for-stp-order');
    const data = {
      FolioTranMode: _data.FolioTranMode,
      SchemeCode: _data.SchemeCode,
      RefKey: "string",
      loader: _data['loader']
    }
    const httpOptions = await this.apiService.getHttpOptionsByToken();
    let result;
    try {
      const response = await this.apiService.post(url, data, httpOptions);
      if (response.Data) {
        result = new InvestorModel.SchemeListForSwitchOM(response.Data).Data;
        this.investorMandateList = of(result);
      }
      return result;
    } catch (error) {
      throw error;
    }
  }

  public async getStpOrderSchemeDataByBse(_data: InvestorModel.SipOrderSchemeInfoVM) {
    const url = this.apiService.getFcApiUrl('/fcapi/mf-order/stp-order/get-scheme-data/by-bse-code');
    const data = {
      BseSchemeCode: _data.BseSchemeCode,
      RefKey: "string",
      loader: _data['loader']
    }
    const httpOptions = await this.apiService.getHttpOptionsByToken();
    let result;
    try {
      const response = await this.apiService.post(url, data, httpOptions);
      if (response.Data) {
        result = new InvestorModel.TransactionDetailsOM(response.Data).Data;
        this.investorMandateList = of(result);
      }
      return result;
    } catch (error) {
      throw error;
    }
  }

  public sipOverview = null;
  public async getSipOverview(_data: InvestorModel.SipVM) {
    const url = this.apiService.getFcApiUrl('/fcapi/reports/mf/investor-sip-overview-this-month');
    const data = {
      InvestorItemType: _data.InvestorItemType,
      InvestorItemId: _data.InvestorItemId,
      RefKey: "string",
      ContextMenuCode: "string",
      loader: _data['loader']
    }
    const httpOptions = await this.apiService.getHttpOptionsByToken();
    let result;
    try {
      const response = await this.apiService.post(url, data, httpOptions);
      if (response.Data) {
        result = new InvestorModel.SipOM(response.Data).Data;
        this.sipOverview = of(result);
      }
      return result;
    } catch (error) {
      throw error;
    }
  }

  public async getFundHoldings(_data: InvestorModel.FundHoldingsVM) {
    const url = this.apiService.getFcApiUrl('/fcapi/mf/scheme/portfolio');
    const data = {
      SchemeCode: _data.SchemeCode,
      FromDate: _data.FromDate,
      ToDate: _data.ToDate,
      RefKey: "string",
      loader: _data['loader']
    };
    const httpOptions = await this.apiService.getHttpOptionsByToken();
    let result;
    try {
      const response = await this.apiService.post(url, data, httpOptions);
      if (response.Data) {
        result = new InvestorModel.FundHoldingsOM(response.Data);
        this.investorMandateList = of(result);
      }
      return result;
    } catch (error) {
      throw error;
    }
  }

  public async getSchemePortfolioSectorWise(_data: InvestorModel.SchemePortfolioSectorWiseVM) {
    const url = this.apiService.getFcApiUrl('/fcapi/mf/scheme/portfolio/sector-wise');
    const data = {
      SchemeCode: _data.SchemeCode,
      RefKey: "string",
      loader: _data['loader']
    };
    const httpOptions = await this.apiService.getHttpOptionsByToken();
    let result;
    try {
      const response = await this.apiService.post(url, data, httpOptions);
      if (response.Data) {
        result = new InvestorModel.SchemePortfolioSectorWiseOM(response.Data);
        this.investorMandateList = of(result);
      }
      return result;
    } catch (error) {
      throw error;
    }
  }

  public async Invoke2Fa(_data: InvestorModel.Invoke2FAVM) {
    const url = this.apiService.getFcApiUrl('/fcapi/mf-order/invoke-bse-2fa');
    const data = {
      OrderID: _data.OrderID,
      TranType: _data.TranType,
      HolderSeq: _data.HolderSeq,
      InvestorId: _data.InvestorId,
      RefKey: "string",
      ContextMenuCode: "string",
    };
    const httpOptions = await this.apiService.getHttpOptionsByToken();
    let result;
    try {
      const response = await this.apiService.post(url, data, httpOptions);
      if (response) {
        result = response;
      }
      return result;
    }
    catch (error) {
      throw error;
    }
  }

  public async BankMandateENACHFetchAuthURL(_data: InvestorModel.BMENACHFetchAuthURLVM) {
    const url = this.apiService.getFcApiUrl('/fcapi/investor/bank-mandate/e-nach/fetch-auth-url');
    const data = {
      refKey: "string",
      contextMenuCode: "string",
      value1: _data.value1,
    };
    const httpOptions = await this.apiService.getHttpOptionsByToken();
    let result;
    try {
      const response = await this.apiService.post(url, data, httpOptions);
      if (response) {
        result = response;
      }
      return result;
    }
    catch (error) {
      throw error;
    }
  }

  public async MakePaymentForNormal(_data: InvestorModel.MakePaymentVM) {
    const url = this.apiService.getFcApiUrl('/fcapi/mf-order/make-payment/normal-order');
    const data = {
      OrderId: _data.OrderId,
      RefKey: "string",
    };
    const httpOptions = await this.apiService.getHttpOptionsByToken();
    let result;
    try {
      const response = await this.apiService.post(url, data, httpOptions);
      if (response.Data) {
        result = new InvestorModel.MakePaymentOM(response.Data);
        this.investorMandateList = of(result);
      }
      return result;
    } catch (error) {
      throw error;
    }
  }

  public async MakePaymentForSIP(_data: InvestorModel.MakePaymentVM) {
    const url = this.apiService.getFcApiUrl('/fcapi/mf-order/make-payment/sip-order');
    const data = {
      OrderId: _data.OrderId,
      RefKey: "string",
    };
    const httpOptions = await this.apiService.getHttpOptionsByToken();
    let result;
    try {
      const response = await this.apiService.post(url, data, httpOptions);
      if (response.Data) {
        result = new InvestorModel.MakePaymentOM(response.Data);
        this.investorMandateList = of(result);
      }
      return result;
    } catch (error) {
      throw error;
    }
  }

  public async RejectOrder(_data: InvestorModel.RejectOrderVM) {
    const url = this.apiService.getFcApiUrl('/fcapi/mf-order/reject-approval');
    const data = {
      InvestorId: _data.InvestorId,
      OrderID: _data.OrderID,
      TranType: _data.TranType,
      Remark: _data.Remark,
      RefKey: "string",
      ContextMenuCode: "string",
    };
    const httpOptions = await this.apiService.getHttpOptionsByToken();
    let result;
    try {
      const response = await this.apiService.post(url, data, httpOptions);
      if (response.Data) {
        result = new InvestorModel.MakePaymentOM(response.Data);
        this.investorMandateList = of(result);
      }
      return result;
    } catch (error) {
      throw error;
    }
  }

  public async ApproveOrderForSystematic(_data: InvestorModel.ApproveOrderVM) {
    const url = this.apiService.getFcApiUrl('/fcapi/mf-order/execute-order/systematic');
    const data = {
      OrderId: _data.OrderId,
      TranType: _data.TranType,
      RefKey: "string",
      ContextMenuCode: "string"
    }
    const httpOptions = await this.apiService.getHttpOptionsByToken();
    let result;
    try {
      const response = await this.apiService.post(url, data, httpOptions);
      if (response.Data) {
        result = new InvestorModel.ApproveOrderOM(response.Data);
        this.investorMandateList = of(result);
      }
      return result;
    } catch (error) {
      throw error;
    }
  }

  public async ApproveOrderForNormal(_data: InvestorModel.ApproveOrderVM) {
    const url = this.apiService.getFcApiUrl('/fcapi/mf-order/execute-order/normal');
    const data = {
      OrderId: _data.OrderId,
      TranType: _data.TranType,
      RefKey: "string"
    }
    const httpOptions = await this.apiService.getHttpOptionsByToken();
    let result;
    try {
      const response = await this.apiService.post(url, data, httpOptions);
      if (response.Data) {
        result = new InvestorModel.ApproveOrderOM(response.Data);
        this.investorMandateList = of(result);
      }
      return result;
    } catch (error) {
      throw error;
    }
  }

  public async InvestorListSearch(_data: InvestorModel.InvestorListSearchVM) {
    const url = this.apiService.getFcApiUrl('/fcapi/investor/list/search');
    const data = {
      SearchType: _data.SearchType,
      SearchValue: _data.SearchValue,
      RefKey: "string",
      ContextMenuCode: "string"
    }
    const httpOptions = await this.apiService.getHttpOptionsByToken();
    let result;
    try {
      const response = await this.apiService.post(url, data, httpOptions);
      if (response.Data) {
        result = new InvestorModel.InvestorListSearchOM(response.Data);
        this.investorMandateList = of(result);
      }
      return result;
    } catch (error) {
      throw error;
    }
  }

  public async InvestorListExtnd() {
    const url = this.apiService.getFcApiUrl('/fcapi/investor/list-extnd');
    const data = {}
    const httpOptions = await this.apiService.getHttpOptionsByToken();
    let result;
    try {
      const response = await this.apiService.post(url, data, httpOptions);
      if (response.Data) {
        result = response.Data;
      }
      return result;
    }
    catch (error) {
      throw error;
    }
  }

  public async SchemePeriodictyAll(_data: InvestorModel.schemePeriodicityVM) {
    const url = this.apiService.getFcApiUrl('/fcapi/mf/scheme/periodicity/all');
    const data = {
      SchemeCode: _data.SchemeCode,
      Periodicity: _data.Periodicity,
      RefKey: "string",
      loader: _data['loader']
    }
    const httpOptions = await this.apiService.getHttpOptionsByToken();
    let result;
    try {
      const response = await this.apiService.post(url, data, httpOptions);
      if (response.Data) {
        result = new InvestorModel.scehemPeriodicityOM(response.Data);
      }
      return result;
    }
    catch (error) {
      throw error;
    }
  }

  public async getSchemeSearch(_data: InvestorModel.schemeSearchVM) {
    const url = this.apiService.getFcApiUrl('/fcapi/mf/scheme/list/for-purchase-order');
    const data = {
      TranMode: _data.TranMode,
      RefKey: "string"
    }
    const httpOptions = await this.apiService.getHttpOptionsByToken();
    let result;
    try {
      const response = await this.apiService.post(url, data, httpOptions);
      if (response.Data) {
        result = new InvestorModel.schemeSearchOM(response.Data).Data;
        this.investorMandateList = of(result);
      }
      return result;
    } catch (error) {
      throw error;
    }
  }

  public async SearchScheme(_data: InvestorModel.SearchSchemeVM) {
    const url = this.apiService.getFcApiUrl('/fcapi/mf/scheme/search/for-mobile');
    const data = {
      SchemeName: _data.SchemeName,
      RefKey: "string",
      loader: _data['loader']
    }
    const httpOptions = await this.apiService.getHttpOptionsByToken();
    let result;
    try {
      const response = await this.apiService.post(url, data, httpOptions);
      if (response.Data) {
        result = new InvestorModel.SearchScehemeOM(response.Data).Data;
        this.investorMandateList = of(result);
      }
      return result;
    } catch (error) {
      throw error;
    }
  }

  public async AUMReportTypes(_data: InvestorModel.AUMReportTypesVM) {
    const url = this.apiService.getFcApiUrl('/fcapi/reports/mf/aum-report-types');
    const data = {
      RefKey: "string"
    };
    const httpOptions = await this.apiService.getHttpOptionsByToken();
    let result;
    try {
      const response = await this.apiService.post(url, data, httpOptions);
      if (response.Data) {
        result = new InvestorModel.AUMReportTypesOM(response.Data);
      }
      return result;
    } catch (error) {
      throw error;
    }
  }

  public async CollectionReportTypes(_data: InvestorModel.CollectionReportTypesVM) {
    const url = this.apiService.getFcApiUrl('/fcapi/reports/mf/collection-report-types');
    const data = {
      RefKey: "string"
    };
    const httpOptions = await this.apiService.getHttpOptionsByToken();
    let result;
    try {
      const response = await this.apiService.post(url, data, httpOptions);
      if (response.Data) {
        result = new InvestorModel.CollectionReportTypesOM(response.Data);
      }
      return result;
    } catch (error) {
      throw error;
    }
  }

  public async AUMReportNC(_data: InvestorModel.AUMReportNCVM) {
    const url = this.apiService.getFcApiUrl('/fcapi/reports/mf/aum-report');
    const data = {
      ReportType: _data.ReportType,
      AsOnDate: _data.AsOnDate,
      ArnNumber: _data.ArnNumber,
      AmcId: _data.AmcId,
      SchCode: _data.SchCode,
      CategoryCode: _data.CategoryCode,
      RefKey: "string",
      loader: _data['loader']
    };
    const httpOptions = await this.apiService.getHttpOptionsByToken();
    let result;
    try {
      const response = await this.apiService.post(url, data, httpOptions);
      if (response.Data) {
        result = new InvestorModel.AUMReportNCOM(response.Data);
      }
      return result;
    } catch (error) {
      throw error;
    }
  }

  public async createSessionData(_data) {
    const url = this.apiService.getFcApiUrl('/fcapi/session-data/create');
    const httpOptions = await this.apiService.getHttpOptionsByToken();
    try {
      const response = await this.apiService.post(url, _data, httpOptions);
      return response;
    } catch (error) {
      throw error;
    }
  }

  public async makePayment(_data: InvestorModel.makePaymentVM) {
    const url = this.apiService.getFcApiUrl(
      `/fcapi/mf-order/make-payment/bse/${_data.sessionKey}`
    );
    const httpOptions = await this.apiService.getHttpOptionsByToken();

    try {
      const response = await this.apiService.get(url, {
        ...httpOptions,
        responseType: 'text' as 'json'
      });
      return response;
    } catch (error) {
      throw error;
    }
  }

  public async CollectionReportNC(_data: InvestorModel.CollectionReportNCVM) {
    const url = this.apiService.getFcApiUrl('/fcapi/reports/mf/collection-report');
    const data = {
      ReportType: _data.ReportType,
      arnNumber: _data.arnNumber,
      AmcId: _data.AmcId,
      SchCode: _data.SchCode,
      CategoryCode: _data.CategoryCode,
      FromDate: _data.FromDate,
      ToDate: _data.ToDate,
      RefKey: "string",
      loader: _data['loader']
    };
    const httpOptions = await this.apiService.getHttpOptionsByToken();
    let result;
    try {
      const response = await this.apiService.post(url, data, httpOptions);
      if (response.Data) {
        result = new InvestorModel.CollectionReportNCOM(response.Data);
      }
      return result;
    } catch (error) {
      throw error;
    }
  }

  public async SIPAllocationReport(_data: InvestorModel.SIPAllocationReportVM) {
    const url = this.apiService.getFcApiUrl('/fcapi/report/mf/sip-allocation');
    const data = {
      refKey: "string",
      fromDate: _data.fromDate,
      toDate: _data.toDate,
      reportWise: _data.reportWise,
      loader: _data['loader']
    };
    const httpOptions = await this.apiService.getHttpOptionsByToken();
    let result;
    try {
      const response = await this.apiService.post(url, data, httpOptions);
      if (response.Data) {
        result = new InvestorModel.SIPAllocationReportOM(response.Data);
      }
      return result;
    } catch (error) {
      throw error;
    }
  }

  public async getBankListByIFSCCode(_data: InvestorModel.BankListByIFSCCodeVM) {
    const url = this.apiService.getFcApiUrl('/fcapi/master-data/bank-list-by-ifsc-code');
    const data = {
      refKey: "string",
      ifscCode: _data.ifscCode,
      loader: _data['loader']
    };
    const httpOptions = await this.apiService.getHttpOptionsByToken();
    let result;
    try {
      const response = await this.apiService.post(url, data, httpOptions);
      if (response.Data) {
        result = new InvestorModel.BankListByIFSCCodeOM(response.Data);
      }
      return result;
    } catch (error) {
      throw error;
    }
  }

  public async addBankAccount(_data: InvestorModel.AddBankAccountOBVM) {
    const url = this.apiService.getFcApiUrl('/fcapi/investor/bank-account/add');
    const data = {
      refKey: "string",
      investorId: _data.investorId,
      bankId: _data.bankId,
      bankName: _data.bankName,
      accountTypeId: _data.accountTypeId,
      accountNumber: _data.accountNumber,
      branchName: _data.branchName,
      ifscCode: _data.ifscCode,
      micrCode: _data.micrCode,
      nameAsPerBank: _data.nameAsPerBank
    };
    const httpOptions = await this.apiService.getHttpOptionsByToken();
    try {
      const response = await this.apiService.post(url, data, httpOptions);
      return response;
    } catch (error) {
      throw error;
    }
  }

  public async authNomineeSendOTP(_data: InvestorModel.authNomineeSendOTPVM) {
    const url = this.apiService.getFcApiUrl('/fcapi/investor/auth-nominee/send-otp');
    const data = {
      refKey: "string",
      investorId: _data.investorId
    };
    const httpOptions = await this.apiService.getHttpOptionsByToken();
    try {
      const response = await this.apiService.post(url, data, httpOptions);
      return response;
    } catch (error) {
      throw error;
    }
  }

  public async authNomineeVerifyOTP(_data: InvestorModel.authNomineeVerifyOTPVM) {
    const url = this.apiService.getFcApiUrl('/fcapi/investor/auth-nominee/verify-otp');
    const data = {
      refKey: "string",
      investorId: _data.investorId,
      holderSeq: _data.holderSeq,
      otpKey: _data.otpKey,
      otpValue: _data.otpValue
    };
    const httpOptions = await this.apiService.getHttpOptionsByToken();
    try {
      const response = await this.apiService.post(url, data, httpOptions);
      return response;
    } catch (error) {
      throw error;
    }
  }

  public async InititateInvestorFUllUCC(_data: InvestorModel.InititateInvestorFullUCCVM) {
    const url = this.apiService.getFcApiUrl('/fcapi/investor/initiate-full-ucc');
    const data = {
      refKey: "string",
      investorId: _data.investorId,
      panNumber: _data.panNumber
    };
    const httpOptions = await this.apiService.getHttpOptionsByToken();
    try {
      const response = await this.apiService.post(url, data, httpOptions);
      return response;
    } catch (error) {
      throw error;
    }
  }

  public async saveFormFatcaIndividual(_data: InvestorModel.SaveFormFatcaIndividualVM) {
    const url = this.apiService.getFcApiUrl('/fcapi/kyc/save-form/fatca-individual');
    const data = {
      refKey: "string",
      investorId: _data.investorId,
      panNumber: _data.panNumber,
      lastSavedKycForm: _data.lastSavedKycForm,
      fatcaCountryId: _data.fatcaCountryId,
      fatcaCity: _data.fatcaCity,
      incomeSlabId: _data.incomeSlabId,
      occupationId: _data.occupationId,
      sourceOfWealthId: _data.sourceOfWealthId,
      pepStatusId: _data.pepStatusId,
      fatcaOtherInfo: _data.fatcaOtherInfo
    };
    const httpOptions = await this.apiService.getHttpOptionsByToken();
    try {
      const response = await this.apiService.post(url, data, httpOptions);
      return response;
    } catch (error) {
      throw error;
    }
  }

  public async saveFormOtherDetails(_data: InvestorModel.SaveFormOtherDetailsVM) {
    const url = this.apiService.getFcApiUrl('/fcapi/kyc/save-form/other-details');
    const data = {
      refKey: "string",
      investorId: _data.investorId,
      panNumber: _data.panNumber,
      lastSavedKycForm: _data.lastSavedKycForm,
      riskProfileId: _data.riskProfileId,
      aadharUpdatedFlag: _data.aadharUpdatedFlag,
      pmsFlag: _data.pmsFlag,
      cmbpId: _data.cmbpId,
      nomineeSOA: _data.nomineeSOA
    };
    const httpOptions = await this.apiService.getHttpOptionsByToken();
    try {
      const response = await this.apiService.post(url, data, httpOptions);
      return response;
    } catch (error) {
      throw error;
    }
  }

  public async getInvestorInfo(_data: InvestorModel.InvestorInfoVM) {
    const url = this.apiService.getFcApiUrl('/fcapi/investor/info');
    const data = {
      refKey: "string",
      InvestorId: _data.investorId
    }
    const httpOptions = await this.apiService.getHttpOptionsByToken();
    try {
      const response = await this.apiService.post(url, data, httpOptions);
      return response;
    } catch (error) {
      throw error;
    }
  }

  public async getFAQList(_data: InvestorModel.FAQListVM) {
    const url = this.apiService.getFcApiUrl('/fcapi/faq/list');
    const data = {
      refKey: "string",
      categoryUQID: _data.categoryUQID
    }
    const httpOptions = await this.apiService.getHttpOptionsByToken();
    try {
      const response = await this.apiService.post(url, data, httpOptions);
      return response;
    } catch (error) {
      throw error;
    }
  }

  public async saveNominee(_data: InvestorModel.NomineeSaveVM) {
    const url = this.apiService.getFcApiUrl('/fcapi/investor/nominee/save');
    const data = {
      refKey: "string",
      nomineeName: _data.nomineeName,
      relationId: _data.relationId,
      relationText: _data.relationText,
      nomineeDob: _data.nomineeDob,
      nomineeTypeId: _data.nomineeTypeId,
      nomineeGuardian: _data.nomineeGuardian,
      nomineeGuardianPAN: _data.nomineeGuardianPAN,
      address1: _data.address1,
      address2: _data.address2,
      address3: _data.address3,
      countryId: _data.countryId,
      stateId: _data.stateId,
      cityId: _data.cityId,
      city: _data.city,
      pinCode: _data.pinCode,
      email: _data.email,
      mobile: _data.mobile,
      idProofTypeLKID: _data.idProofTypeLKID,
      idProofNum: _data.idProofNum,
      nomineeId: _data.nomineeId,
      investorId: _data.investorId,
      sharingPerc: _data.sharingPerc
    }
    const httpOptions = await this.apiService.getHttpOptionsByToken();
    try {
      const response = await this.apiService.postSN(url, data, httpOptions, true);
      return response;
    } catch (error) {
      throw error;
    }
  }

  public async createNewInvestor(_data: InvestorModel.InvestorCreateNewVM) {
    const url = this.apiService.getFcApiUrl('/fcapi/investor/create-new');
    const data = {
      refKey: "string",
      taxStatusId: _data.taxStatusId,
      panNumber: _data.panNumber,
      mobile: _data.mobile,
      isMobileVerified: _data.isMobileVerified,
      email: _data.email,
      investorDob: _data.investorDob,
      guardianDob: _data.guardianDob,
      investorName: _data.investorName,
      fullDpId: _data.fullDpId,
      dpCode: _data.dpCode,
      xRef1Type: _data.xRef1Type,
      xRef1Data: _data.xRef1Data,
      bankAccountNo: _data.bankAccountNo,
      holder1MobileBelongsTo: _data.holder1MobileBelongsTo,
      holder1EmailBelongsTo: _data.holder1EmailBelongsTo,
      mapTo: undefined as any
    };
    if (_data.mapTo) {
      data.mapTo = _data.mapTo;
    }
    const httpOptions = await this.apiService.getHttpOptionsByKey();
    try {
      const response = await this.apiService.post(url, data, httpOptions);
      return response;
    } catch (error) {
      throw error;
    }
  }

  public async ForgotPasswordSentOTP(_data: InvestorModel.ForgotPasswordSentOTPVM) {
    const url = this.apiService.getFcApiUrl('/fcapi/account/forget-password/send-otp');
    const data = {
      LoginName: _data.LoginName,
      RefKey: "string",
    };
    const httpOptions = await this.apiService.getHttpOptionsByKey();
    try {
      const response = await this.apiService.post(url, data, httpOptions);
      return response;
    } catch (error) {
      throw error;
    }
  }

  public async ForgotPasswordResetByOTP(_data: InvestorModel.ForgotPasswordResetByOTPVM) {
    const url = this.apiService.getFcApiUrl('/fcapi/account/forget-password/reset-by-otp');
    const data = {
      LoginName: _data.LoginName,
      OtpKey: _data.OtpKey,
      OtpValue: _data.OtpValue,
      RefKey: "string",
    };
    const httpOptions = await this.apiService.getHttpOptionsByKey();
    try {
      const response = await this.apiService.post(url, data, httpOptions);
      return response;
    } catch (error) {
      throw error;
    }
  }

  public async CreateInvestorExecuteV1(_data: InvestorModel.CreateInvestorV1VM) {
    const url = this.apiService.getFcApiUrl('/fcapi/investor/create-investor/execute/v1');
    const data = {
      refKey: "string",
      taxStatusId: _data.taxStatusId,
      panNumber: _data.panNumber,
      investorCode: _data.investorCode,
      investorName: _data.investorName,
      investorFirstName: _data.investorFirstName,
      investorMiddleName: _data.investorMiddleName,
      investorLastName: _data.investorLastName,
      loginName: _data.loginName,
      uccFlag: _data.uccFlag,
      panKycFlag: _data.panKycFlag,
      fatcaFlag: _data.fatcaFlag,
      tiffFlag: _data.tiffFlag,
      dob: _data.dob,
      guardianName: _data.guardianName,
      guardianFirstName: _data.guardianFirstName,
      guardianMiddleName: _data.guardianMiddleName,
      guardianLastName: _data.guardianLastName,
      guardianDob: _data.guardianDob,
      guardianRelationshipId: _data.guardianRelationshipId,
      mobile: _data.mobile,
      email: _data.email,
      holder1MobileBelongsTo: _data.holder1MobileBelongsTo,
      holder1EmailBelongsTo: _data.holder1EmailBelongsTo,
      gender: _data.gender,
      occupationId: _data.occupationId,
      address1: _data.address1,
      address2: _data.address2,
      address3: _data.address3,
      cityId: _data.cityId,
      cityName: _data.cityName,
      stateId: _data.stateId,
      countryId: _data.countryId,
      pinCode: _data.pinCode,
      bankId: _data.bankId,
      accountNumber: _data.accountNumber,
      ifscCode: _data.ifscCode,
      micrCode: _data.micrCode,
      accountTypeId: _data.accountTypeId,
      nominee1: {
        refKey: "string",
        nomineeName: _data.nominee1?.nomineeName,
        relationId: _data.nominee1?.relationId,
        relationText: _data.nominee1?.relationText,
        nomineeTypeId: _data.nominee1?.nomineeTypeId,
        nomineeDob: _data.nominee1?.nomineeDob,
        nomineeGuardian: _data.nominee1?.nomineeGuardian,
        nomineeGuardianPAN: _data.nominee1?.nomineeGuardianPAN,
        address1: _data.nominee1?.address1,
        address2: _data.nominee1?.address2,
        address3: _data.nominee1?.address3,
        countryId: _data.nominee1?.countryId,
        stateId: _data.nominee1?.stateId,
        cityId: _data.nominee1?.cityId,
        city: _data.nominee1?.city,
        pinCode: _data.nominee1?.pinCode,
        email: _data.nominee1?.email,
        mobile: _data.nominee1?.mobile,
        idProofTypeLKID: _data.nominee1?.idProofTypeLKID,
        idProofNum: _data.nominee1?.idProofNum,
      },
      fatcaCountryId: _data.fatcaCountryId,
      sourceOfWealthId: _data.sourceOfWealthId,
      incomeSlabId: _data.incomeSlabId,
      netWorthIncome: _data.netWorthIncome,
      pepStatusId: _data.pepStatusId,
      riskProfileId: _data.riskProfileId,
      kycMode: _data.kycMode,
      mapToSubBrokerId: _data.mapToSubBrokerId,
      mapToRmId: _data.mapToRmId,
      mfTranModeId: _data.mfTranModeId,
      depositoryId: _data.depositoryId,
      nsdlDpId: _data.nsdlDpId,
      nsdlAccNo: _data.nsdlAccNo,
      cdslAccNo: _data.cdslAccNo,
      benfAccNo: _data.benfAccNo,
    };
    const httpOptions = await this.apiService.getHttpOptionsByToken();
    let result;
    try {
      const response = await this.apiService.post(url, data, httpOptions);
      if (response.Data) {
        result = new InvestorModel.CreateInvestorV1OM(response.Data);
      }
      return result;
    } catch (error) {
      throw error;
    }
  }

  public async ForgotPasswordResendOTP(_data: InvestorModel.ForgotPasswordResendOTPVM) {
    const url = this.apiService.getFcApiUrl('/fcapi/notification/resend-otp');
    const data = {
      OtpKey: _data.OtpKey,
      RefKey: "string",
    };
    const httpOptions = await this.apiService.getHttpOptionsByKey();
    try {
      const response = await this.apiService.post(url, data, httpOptions);
      return response;
    } catch (error) {
      throw error;
    }
  }

  public async ValidateUserDetailsForMobileOTP(_data: InvestorModel.ValidateUserDetailsForMobileOTPVM) {
    const url = this.apiService.getFcApiUrl('/fcapi/account/validate-user-details-for-mobile-otp');
    const data = {
      ScreenCode: _data.ScreenCode,
      MobileNumber: _data.MobileNumber,
      UserType: _data.UserType,
      UserCode: _data.UserCode,
      RefKey: "string",
      ContextMenuCode: "string",
    }
    const httpOptions = await this.apiService.getHttpOptionsByKey();
    try {
      const response = await this.apiService.post(url, data, httpOptions);
      return response;
    } catch (error) {
      throw error;
    }
  }

  public async MFOrderRecheckPaymentStatus(_data: InvestorModel.MFOrderRecheckPaymentStatus) {
    const url = this.apiService.getFcApiUrl('/fcapi/mf-order/recheck-payment-status');
    const data = {
      refKey: "string",
      gwsOrderId: _data.gwsOrderId,
      tranType: _data.tranType
    };
    const httpOptions = await this.apiService.getHttpOptionsByToken();
    try {
      const response = await this.apiService.postSN(url, data, httpOptions);
      return response;
    } catch (error) {
      return null;
    }
  }

  public async MFOrderDetail(_data: InvestorModel.MFOrderDetail) {
    const url = this.apiService.getFcApiUrl('/fcapi/mf-order/order-detail');
    const data = {
      refKey: "string",
      investorId: _data.investorId,
      gwsOrderId: _data.gwsOrderId,
      tranType: _data.tranType,
      includeDisplayData: _data.includeDisplayData
    };
    const httpOptions = await this.apiService.getHttpOptionsByToken();
    try {
      const response = await this.apiService.post(url, data, httpOptions);
      return response;
    } catch (error) {
      throw error;
    }
  }

  public async ValidateMobileOTPForLogin(_data: InvestorModel.ValidateMobileOTPForLoginVM) {
    const url = this.apiService.getFcApiUrl('/fcapi/account/validate-mobile-otp-for-login');
    const data = {
      OtpKey: _data.OtpKey,
      OtpValue: _data.OtpValue,
      AccCode: _data.AccCode,
      RefKey: "string",
      ContextMenuCode: "string",
    }
    const httpOptions = await this.apiService.getHttpOptionsByKey();
    try {
      const response = await this.apiService.post(url, data, httpOptions);
      return response;
    } catch (error) {
      throw error;
    }
  }

  public async ValidateUserDetailsForMobileOTPOB(_data: InvestorModel.ValidateUserDetailsForMobileOTPOBVM) {
    const url = this.apiService.getFcApiUrl('/fcapi/account/validate-user-details-for-mobile-otp');
    const data = {
      refKey: "string",
      screenCode: _data.screenCode,
      mobileNumber: _data.mobileNumber,
      mobileEnc: _data.mobileEnc,
      userType: _data.userType,
      userCode: _data.userCode,
    }
    const httpOptions = await this.apiService.getHttpOptionsByKey();
    try {
      const response = await this.apiService.post(url, data, httpOptions);
      return response;
    } catch (error) {
      throw error;
    }
  }

}